import { Store, Action, Dispatch, AnyAction, Middleware } from 'redux';

import { ResponseError } from '@swagger-http';

import { RootState } from '@store/types';
import { getNewToken } from '@store/actions';
import { goToLogin, handleError, isTokenExpired } from '@tools/utils';

let refreshingToken = false;

export const auth: Middleware =
    (store: Store<RootState>) =>
    (next: Dispatch<AnyAction>) =>
    async <A extends Action>(action: A) => {
        if (typeof action !== 'function') {
            return next(action);
        }

        if (isTokenExpired(store) && !refreshingToken) {
            refreshingToken = true;

            await getNewToken(store)
                .catch(async (e: ResponseError) => {
                    await handleError(e, 'Error when getting a new token:');

                    goToLogin();
                })
                .finally(() => {
                    refreshingToken = false;
                });

            return next(action);
        }

        return next(action);
    };
